export const styles = ({ palette, breakpoints }) => ({
  separator: {
    borderColor: 'rgba(213, 214, 216, 0.5)',
    margin: '0px 0',
    width: '100%',
  },
});
